import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { PlatformSettings } from '@/types/superadmin';

export function useSuperAdminSettings() {
  return useQuery<PlatformSettings>({
    queryKey: ['superadmin', 'settings'],
    queryFn: async () => {
      const { data } = await api.get('/superadmin/settings');
      return data;
    },
  });
}

export function useUpdateSuperAdminSettings() {
  const queryClient = useQueryClient();
  return useMutation<PlatformSettings, Error, Partial<PlatformSettings>>({
    mutationFn: async (payload) => {
      const { data } = await api.patch('/superadmin/settings', payload);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['superadmin', 'settings'] });
    },
  });
}
